module.exports = __webpack_public_path__ + "img/admin-is-working.8e78cfca.png";